export enum ClpTableEnum {
  Deviations = "deviations",
  Documents = "documents",
  IssueReportsArchive = "issue_reports_archive",
  IssueReportsArchiveHistory = "issue_reports_archive_history",
  IssueReportsCategories = "issue_reports_categories",
  IssuReportsWorkOrders = "issu_reports_work_orders",
  LearningAdminResults = "learning_admin_results",
  NewsAdmin = "news_admin",
  Payslips = "payslips",
  SettingsCompanies = "settings_companies",
  SettingsCompaniesWorkshops = "settings_companies_workshops",
  SettingsCustomerRoles = "settings_customer_roles",
  SettingsUsersCustomFieldCategories = "settings_users_custom_field_categories",
  SettingsUsersCustomFields = "settings_users_custom_fields",
  SettingsUsersRegistry = "settings_users_registry",
  SysAdminCompanies = "sys_admin_companies",
  SysAdminCompaniesWorkshops = "sys_admin_companies_workshops",
  SysAdminCustomers = "sys_admin_customers",
  SysAdminUsersRegistry = "sys_admin_users_registry",
  SystemEvents = "system_events",
  UserReports = "user_reports",
  UserReportsBkyChecks = "user_reports_bky_checks",
  VehicleAlarm = "vehicle_alarm",
  VehicleAlarmSettings = "vehicle_alarm_settings",
  VehicleRegistryChecks = "vehicle_registry_checks",
  VehicleRegistryChecksHistory = "vehicle_registry_checks_history",
  VehicleRegistryDetailsChecks = "vehicle_registry_details_checks",
  VehicleRegistryDetailsChecksHistory = "vehicle_registry_details_checks_history",
  VehicleRegistryDetailsExpenses = "vehicle_registry_details_expenses",
  VehicleRegistryDetailsIssueReports = "vehicle_registry_details_issue_reports",
  VehicleRegistrySettingsCustomFieldGroups = "vehicle_registry_settings_custom_field_groups",
  VehicleRegistrySettingsCustomFields = "vehicle_registry_settings_custom_fields",
  VehicleRegistryVehicles = "vehicle_registry_vehicles",
  VehicleReports = "vehicle_reports",
  VehicleReportsContract = "vehicle_reports_contract",
  VehicleReportsFuelData = "vehicle_reports_fuel_data",
  Violation = "violation"
}
